export class UrlConstants{
    public static LOGIN = "/login";
    public static HOME = "/main/home/index";
}


// WEBPACK FOOTER //
// D:/01.Developer/0.Web/Bravo8-Base/src/app/core/common/url.constants.ts